import { c as _c } from "react/compiler-runtime";
import type { IntendedAlertMessage } from '@module/types/centrifuge/public-message/etcMessageTypes';
interface Props {
  item: IntendedAlertMessage;
}
export default function IntendedAlertChat(props) {
  const $ = _c(2);
  const {
    item
  } = props;
  const {
    message
  } = item.data;
  let t0;
  if ($[0] !== message) {
    t0 = <div className="mb-[3px] whitespace-pre-wrap text-cht_al_2"><div>{message}</div></div>;
    $[0] = message;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}